import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';

const ChatLog = ({ chatLog }) => {
    const logRef = useRef(null);

    useEffect(() => {
        if (logRef.current) {
            logRef.current.scrollTop = logRef.current.scrollHeight;
        }
    }, [chatLog]);

    if (!Array.isArray(chatLog)) {
        console.error('Expected chatLog to be an array, but received:', chatLog);
        return null;
    }

    return (
        <div className="chat-log-container" ref={logRef}>
            {chatLog.map((message, index) => (
                <ChatMessage key={index} message={message} />
            ))}
        </div>
    );
};

export default ChatLog;